/** Maps office/group branding fields onto BrandedComponentWrapper's `brand` prop. */
export function toBrandedWrapperBrand(
  source: {
    name: string;
    logo?: string | null;
    headerColor?: string | null;
    address?: string | null;
    address1?: string | null;
    address2?: string | null;
    phone?: string | null;
    phoneNumber?: string | null;
    showBrandLogoOnLink?: boolean;
  },
  options?: {
    /** Force showing name/phone even when showBrandLogoOnLink is unset/false. */
    showBrand?: boolean;
  }
) {
  const joinedAddress = [source.address1, source.address2].filter(Boolean).join(" ") || null;

  return {
    name: source.name,
    logo: source.logo ?? null,
    headerColor: source.headerColor ?? null,
    address: source.address ?? joinedAddress,
    phone: source.phone ?? source.phoneNumber ?? null,
    showBrandLogoOnLink: options?.showBrand ?? source.showBrandLogoOnLink ?? true,
  };
}
